<template>
  <main>
    <h1 class="home-title">Adman Awards &amp; Symposium</h1>
    <Date />
    <Sponsor />
  </main>
</template>

<script>
import { getBaseURL, getBaseMetaCurrentYear } from '@/environments'

const Date = () => import('@/components/Date/Main')
const Sponsor = () => import('@/components/Sponsor/Main')

export default {
  components: {
    Date,
    Sponsor
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: getBaseURL() },
      { name: 'og:title', content: `Adman Awards & Symposium ${getBaseMetaCurrentYear}` },
      { name: 'og:description', content: 'Be the First Winner of the Most Honorable Award' },
      { name: 'og:image', content: `${getBaseURL()}/img/og_adman.jpg` },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  }
}
</script>

<style scoped>
.home-title {
  position: absolute;
  overflow: hidden;
  margin: -1px;
  padding: 0;
  width: 1px;
  height: 1px;
  border: 0;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
</style>
